module.exports = __webpack_public_path__ + "stylesheets/icon-text-list_e503683656aa9b351ad23d6a1733c12a.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/icon-text-list.less
// module id = 5G1g
// module chunks = 151